module.exports = __webpack_public_path__ + "static/media/icon-engine-default.ebe0b013.svg";